import { createContext } from "react";
import useFetch from "../hooks/useFetch";

const OrganizationContext = createContext(null);

function OrganizationContextProvider({ children }) {
  
    const { data, error, loading, refresh } = useFetch(
      `${process.env.REACT_APP_BACKEND_BASE_URL}/organizations/`
    );

    const value = {
      data,
      error,
      loading,
      refresh,
    };
  
    return (
      <OrganizationContext.Provider value={value}>{children}</OrganizationContext.Provider>
    );
  }

export { OrganizationContext };
export default OrganizationContextProvider